import(/* webpackMode: "eager" */ "/app/lib/StyledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Loader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LoaderCustom/components/LoaderImg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LoaderCustom/components/LoaderVideo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/styles/GlobalStyles.tsx");
